import React, { useEffect, useState } from "react";
import { Container, Row } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import { Table, Select } from "antd";
import "bootstrap/dist/css/bootstrap.css";

import { Link } from "react-router-dom";
import ApiService from "../util/ApiService";
import LoadingScreen from "../util/LoadingScreen";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import CustomPagination from "../util/CustomPagination";
import "./assets/css/ReviewsRealize.css"; // Adicionamos o CSS responsivo aqui

const MySwal = withReactContent(Swal);
const { Option } = Select;

const ReviewsRealize = () => {
    document.title = "Avaliações Realizadas | Plantão Rápido";
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false); // Carregamento da tabela
    const [loadingPage, setLoadingPage] = useState(false); // Carregamento da página inteira ao excluir
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0, lastPage: 0 });
    const [filter, setFilter] = useState("user");

    useEffect(() => {
        fetchRatings();
    }, [pagination.current, pagination.pageSize, filter]);

    const fetchRatings = async () => {
        setLoading(true); // Inicia o carregamento da tabela
        try {
            const response = await ApiService.send(
                "get",
                `${process.env.REACT_APP_URL_API}users/rating-list-realize`,
                {
                    pagination: pagination.pageSize,
                    page: pagination.current,
                    type: filter,
                },
                true
            );

            const { data, pagination: pagInfo } = ApiService.handleApiResponse(response);
            setData(data || []);
            setPagination(pagInfo || { current: 1, pageSize: 10, total: 0 });



        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false); // Encerra o carregamento da tabela após a busca
        }
    };

    const handleDelete = async (reviewId) => {
        if (reviewId) {
            setLoadingPage(true); // Inicia o carregamento da página ao excluir
            try {
                const response = await ApiService.send(
                    "delete",
                    `${process.env.REACT_APP_URL_API}users/delete-rating/${reviewId}`,
                    {
                        type: filter,
                    },
                    true
                );

                if (response && response.code === 200) {
                    fetchRatings();
                    Swal.fire({
                        icon: "success",
                        title: "Sucesso!",
                        text: response.data.message,
                        confirmButtonText: "Ok",
                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Erro",
                        text: response.data.errors
                            ? response.data.errors.join(", ")
                            : "Erro ao excluir a avaliação.",
                        confirmButtonText: "Ok",
                    });
                }
            } catch (error) {
                ApiService.handleApiError(error);
            } finally {
                setLoadingPage(false); // Encerra o carregamento da página após a exclusão
            }
        }
    };

    const confirmDelete = (reviewId) => {
        MySwal.fire({
            title: "Você tem certeza?",
            text: "Esta ação não poderá ser desfeita!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sim, excluir!",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                handleDelete(reviewId);
            }
        });
    };

    const columns = [
        {
            title: filter === "user" ? "Usuário/Empresa" : "Hospital",
            dataIndex: "name",
            render: (text, record) => (
                <>
                    <Link
                        className="avatar mx-2"
                        to={
                            filter === "user"
                                ? "/admin/detail/" + record.page_url
                                : "/admin/location-detail/" + record.page_url
                        }
                    >
                        <img
                            className="rounded-circle"
                            src={
                                record.image ||
                                (filter === "user"
                                    ? `${process.env.REACT_APP_URL_STORAGE}src/perfil_icone.png`
                                    : `${process.env.REACT_APP_URL_STORAGE}src/hospital_icone.png`)
                            }
                            alt={filter === "user" ? "Paciente" : "Hospital"}
                            style={{ width: "40px", height: "40px" }} // Tamanho ajustado
                        />
                    </Link>
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={
                            filter === "user"
                                ? "/admin/detail/" + record.url_page
                                : "/admin/location-detail/" + record.url_page
                        }
                    >
                        {text}
                    </a>
                </>
            ),
            sorter: (a, b) => a.name.localeCompare(b.name),
            width: 200,
        },
        {
            title: "Comentário",
            dataIndex: "comment",
            render: (text) => (
                <p style={{ whiteSpace: "normal", wordWrap: "break-word", marginBottom: 0 }}>
                    {text || "Nenhuma descrição disponível"}
                </p>
            ),
            sorter: (a, b) => (a.comment || "").localeCompare(b.comment || ""),
            width: "auto",
        },
        {
            title: "Avaliação",
            dataIndex: "rating",
            render: (rating) => (
                <span>
          {[...Array(5)].map((_, i) => (
              <i
                  key={i}
                  className={`fe fe-star ${i < rating ? "text-warning" : "text-secondary"}`}
              ></i>
          ))}
        </span>
            ),
            width: 150,
        },
        {
            title: "Data",
            render: (record) => <span>{new Date(record.created_at).toLocaleString()}</span>,
            sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
            width: 180,
        },
        {
            title: "Ação",
            className: "text-end",
            render: (text, record) => (
                <div className="text-end">
                    <a
                        href="#"
                        className="me-1 btn btn-sm bg-danger-light"
                        onClick={() => confirmDelete(record.id)}
                    >
                        <i className="fa fa-trash" aria-hidden="true"></i> Excluir
                    </a>
                </div>
            ),
            width: 100,
        },
    ];

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Realizadas" pageTitle="Avaliações"/>
                    <Row>
            {loadingPage && <LoadingScreen />} {/* Exibe apenas ao excluir */}


                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body">
                                    <Select
                                        defaultValue="user"
                                        onChange={(value) => setFilter(value)}
                                        style={{ marginBottom: 20 }}
                                    >
                                        <Option value="user">Usuário/Empresa</Option>
                                        <Option value="hospital">Local</Option>
                                    </Select>

                                    <div className="table-responsive">
                                        <Table
                                            loading={loading} // Carregamento da tabela
                                            columns={columns}
                                            pagination={false}
                                            locale={{
                                                emptyText: "Nenhum dado disponível",
                                            }}
                                            dataSource={data}
                                            rowKey={(record) => record.id}
                                            className="responsive-table"
                                        />
                                    </div>

                                    <CustomPagination
                                        pagination={pagination}
                                        onChange={(page) => setPagination({ ...pagination, current: page })}

                                    />
                                </div>
                            </div>
                        </div>


</Row>
</Container>
</div>
</React.Fragment>


    );
};

export default ReviewsRealize;
